import * as types from './mutation-types'

export default {
  [types.LOAD_QVCT_ANSWER_MARK](state, data) {
    state.qvctAnswerMark = data
  },

}
